import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Embedded_Syllabus from "./Pages/Embedded_Syllabus";
import Home from "../src/Pages/Home";
import Master from "./Layout/Master";
import FullStack from "../src/Pages/FullStack";
import FullStack_45days from "../src/Pages/FullStack_45days";
import ComingSoon from "./Components/ComingSoon";
import Blog from "./Pages/Blog";
import First_Blog from "./Pages/First_Blog";
import Second_Blog from "./Pages/Second_blog";
import Thired_Blog from "./Pages/Third_Blog";
import React_Native from "./Pages/React_Native";
import Machine_Learning from "./Pages/Machine_Learning";
import Robotics from "./Pages/Robotics";


function App() {
  return (
    <div className="App">
      <>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Master />}>
              <Route path="/" element={<Home />} />
              <Route path="/embedded_system" element={<Embedded_Syllabus />} />
              <Route path="/robotics" element={<Robotics/>} />
              <Route path="/fullstack_syllabus" element={<FullStack />} />
              <Route path="/react_native" element={<React_Native/>} />
              <Route path="/machine_learning_syllabus" element={<Machine_Learning/>} />
              <Route
                path="/45days_fullstack_syllabus"
                element={<FullStack_45days />}
              />
              <Route path="/blogs" element={<Blog />} />
              <Route path="/ai_revolution" element={<First_Blog />} />
              <Route path="/machine_learning" element={<Second_Blog />} />
              <Route path="/robotics" element={<Thired_Blog />} />
            </Route>
            <Route path="/comingsoon" element={<ComingSoon />} />
          </Routes>
        </BrowserRouter>
      </>
    </div>
  );
}

export default App;
